
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard  {
  constructor(
    private translate: TranslateService
  ) { }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    if (component == null || component === undefined){
      return true;
    }
    return component.canDeactivate() ?
      true :
    confirm(this.translate.instant('Warning.PageIsUploading') + ' Press Cancel to go back, or OK to lose page.');
  }
}
